import {FC, memo} from 'react';
import {useT, IDocumentQueueItem} from '@kcast-fe/core';
import {Grid, GridItem, Stack} from '@chakra-ui/react';
import {Svg} from 'ui-kit';

interface IProps {
  queueErrors: Array<IDocumentQueueItem>;
}

const DocQueueErrorsFC: FC<IProps> = ({queueErrors}) => {
  const {t} = useT();

  return (
    <Stack p={queueErrors.length === 0 ? '0' : '8px 0'} gap={'8px'}>
      {queueErrors.map((item) => (
        <Grid
          p={'12px'}
          gap={'8px'}
          key={item.id}
          borderRadius={'12px'}
          bg={'{colors.stateError}'}
          gridTemplateColumns={'20px 1fr'}
          color={'{colors.white}'}
          alignItems={'center'}
        >
          <GridItem>
            <Svg name={'Warn'} size={'s20'} />
          </GridItem>

          <GridItem>{item.error ? item.error : t('errors.uploadFailed')}</GridItem>
        </Grid>
      ))}
    </Stack>
  );
};

export const DocQueueErrors = memo(DocQueueErrorsFC);
